export default "__VITE_ASSET__0xsr4$_6__"